export interface BrowserFeatures {
  navigator: { sendBeacon?: unknown }
  Promise: { allSettled?: unknown }
  Array: { prototype: { flatMap?: unknown } }
}

/**
 * Check for required browser features.
 *
 * The Doppler client requires these modern browser APIs to function properly:
 * - navigator.sendBeacon: For reliable beacon transmission
 * - Promise.allSettled: For handling multiple async operations
 * - Array.prototype.flatMap: For data processing operations
 *
 * @param features - Browser objects to check for required features
 * @returns true if all required features are supported
 */
export function detectFeatures(features: BrowserFeatures): boolean {
  return (
    typeof features.navigator.sendBeacon === "function" &&
    typeof features.Promise.allSettled === "function" &&
    typeof features.Array.prototype.flatMap === "function"
  )
}
